<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('investmentOpportunity.form.interest') }}</span>
          
          <div class="float-right" >
            <a href="#interest" name="action" @click="addInterest"  v-if="compMode != CRUDMODE.READ">
              <span class="fa fa-plus fa-lg"></span>
            </a>
            &nbsp;
            <a href="#section" name="section" v-on:click="expandOrCollapse">
              <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
            </a>
          </div>
        </div>
        <div class="card-body" v-if="localVisible">
          <div class="row">

            <table id="dataTableAction" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th width="300">{{ $t('investmentOpportunity.form.interestMemberName') }}</th>
                  <th>{{ $t('investmentOpportunity.form.interestDate') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                <th width="300">{{ $t('investmentOpportunity.form.interestMemberName') }}</th>
                  <th>{{ $t('investmentOpportunity.form.interestDate') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </tfoot>
              <tbody>
                <tr class="odd" v-if="interests == null || interests.length == 0">
                    <td valign="top" colspan="4" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                </tr>

                <tr v-for="(item, index) in interests" v-bind:data-id="item.id" :key="item.id">
                  
                  <td>
                     <multiselect v-model="item.member" id="ajax" :custom-label="memberLabel" 
                        track-by="id" :placeholder="$t('project.investment.form.history.member')"
                        open-direction="bottom"
                        :loading="isLoading" 
                        :options="members" :multiple="false" :searchable="true" 
                        :options-limit="300" :max-height="600" :show-no-results="true" 
                         @search-change="asyncMemberFind"
                         @select="f => onMemberSelect(this, f, index)"
                        :select-label="$t('multiselect.select-label')">
                        <!--  @search-change="asyncFindMember" -->

                        <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
                      </multiselect>
                  </td>
                  <td>
                      <span> {{ date(item) }} </span>
                  </td>
                  <td align="center" v-if="compMode != CRUDMODE.READ">
                    <a  class="text-danger" v-bind:title="$t('form.delete_button')" href="#entrepreneur" v-on:click="removeAction(index)">
                        <span class="fa fa-lg fa-trash"></span>
                    </a>
                  </td> 
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    InvestmentOpportunityServiceClient,
    InvestmentOpportunityInterestDto,
    MemberServiceClient,
    MemberDto,
} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import MomentDatePicker from '../../shared/components/MomentDatePicker'
  import store from '../../store'
  export default {
    name: 'InvestmentOpportunityInterests',
    props: {
      interests: {
        type: Array,
        default: function() {
          return []
        },
      },
    },
    data() {
      return {
        members: [],
        isLoading: false,
        localVisible: true,
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.setMode()
      }, 1000)
    },
    methods: {
      fetchData: function() {
        // Empty for crudmixin, we don't really need it
      },
      onMemberSelect: function(obj, f, index) {
        this.$set(this.interests[index], 'memberId', f.id)
      },
      date: function(interestDto) {
        if (interestDto.id != null) {
          return `Intérêt ajouté le ${interestDto.creationTime.format('DD/MM/YYYY')}`
        }
      },
      expandOrCollapse: function() {
        this.localVisible = !this.localVisible
      },
      addInterest: function() {
        let dto = new InvestmentOpportunityInterestDto()
        dto.init({})

        this.interests.push(dto)
      },
      asyncMemberFind: function(query) {
        this.isLoading = true
  
        let service = ServiceFactory.create(MemberServiceClient)
        let self = this

        service.getAutocomplete(query).then(response => {
          self.members = _.map(response, item => {
            let dto = new MemberDto()
            dto.init(item)
            return dto
          })
          self.isLoading = false
        })
      },
      removeAction: function(index) {
        this.interests.splice(index, 1)
      },
      memberLabel: function(obj) {
        return obj.familyName + ', ' + obj.name
      },
    },
    components: {
      'moment-date-picker': MomentDatePicker,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/InvestmentOpportunity/InvestmentOpportunityInterests.vue